const url = 'https://server.adhirajasatranssejahtera.id/';
// const url = 'http://localhost:3000/';

export { url };
